import { Background } from "../Base/Background";

interface NotFoundPageProps {
  homeHref?: string;
}

export function NotFoundPage({ homeHref = "/" }: NotFoundPageProps) {
  return (
    <div className="relative flex min-h-screen bg-surface items-center justify-center px-4">
      <Background />
      <div
        className="relative flex flex-col justify-center text-center max-w-md bg-white rounded-2xl border border-gray-100 p-8"
        style={{ background: "rgba(255, 255, 255, 0.9)" }}
      >
        <h1 className="text-5xl font-bold text-ink">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-ink">Page not found</h2>
        <p className="mt-2 text-sm text-gray-600">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <a
          href={homeHref}
          className="mt-6 inline-block rounded-lg bg-secondary-400 hover:bg-secondary-300 px-6 py-3 text-sm font-semibold text-white transition-colors"
        >
          Go back home
        </a>
      </div>
    </div>
  );
}
